import * as React from 'react';

import { FormInputsLayout } from '../FormInputsLayout';

import * as styles from './styles.css';

export interface IFIOSuggestProps {
  inputValue: string;
  inputName: string;
  placeholder: React.ReactNode;
  suggestFiltered: React.ReactNode;
  inputRef: React.RefObject<HTMLInputElement> | null;
  onChange(value: string): void;
  onFocus(): void;
}

// eslint-disable-next-line react/display-name
export const FIOSuggest = React.forwardRef<HTMLInputElement, IFIOSuggestProps>((props, ref) => {
  const { onChange, onFocus, inputValue, suggestFiltered, placeholder, inputName } = props;

  return (
    <div className={styles['container']}>
      <div className={styles['input-container']}>
        <FormInputsLayout
          InputProps={{
            inputRef: ref,
            value: inputValue,
            name: inputName,
            onFocus,
            onChange: e => onChange(e.target.value),
          }}
          fullwidth
        />
      </div>
      {placeholder}
      {suggestFiltered}
    </div>
  );
});
